import { useMemo } from 'react';
import { languages } from '../../../static-data/languages';
import AutocompleteField from '../../../ui/primitives/AutocompleteField ';

const LANGUAGE_OPTIONS = languages;

const LanguageSelect = ({ selectedValues = [], setSelectedValues }) => {
  const normalizedValues = useMemo(
    () =>
      selectedValues.map((v) =>
        typeof v === 'string'
          ? (LANGUAGE_OPTIONS.find((l) => l.name === v) ?? { name: v })
          : v,
      ),
    [selectedValues],
  );

  const handleChange = (newValues) => {
    setSelectedValues(newValues.map((v) => v.name));
  };

  return (
    <AutocompleteField
      id="language-select"
      label="Select Languages"
      required
      multiple
      value={normalizedValues}
      onChange={handleChange}
      options={LANGUAGE_OPTIONS}
      placeholder="Languages"
      filterSelectedOptions
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.name === value.name}
      limitTags={7}
    />
  );
};

export default LanguageSelect;